import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";

export class Trails extends DisplayObject {
    //private anim: Spine | null = null;
    public greenTrail: Spine | null = null;
    public blueTrail: Spine | null = null;
    public pinkTrail: Spine | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
    }

    private init(): void {
        this.greenTrail = Spine.from({
            skeleton: "spGreenTrailSkel",
            atlas: "spGreenTrailAtlas",
        });
        this.blueTrail = Spine.from({
            skeleton: "spBlueTrailSkel",
            atlas: "spBlueTrailAtlas"
        });
        this.pinkTrail = Spine.from({
            skeleton: "spPinkTrailSkel",
            atlas: "spPinkTrailAtlas"
        });
        this.greenTrail.state.timeScale = 0.5
        this.blueTrail.state.timeScale = 0.5
        this.pinkTrail.state.timeScale = 0.5
        this.addChild(this.greenTrail);
        this.addChild(this.blueTrail);
        this.addChild(this.pinkTrail);
    }

    public triggerTrail(symbol: Spine, meter: Spine, id: number, callback: () => void) {
        symbol;
        meter;
        id;
        callback;
    }
}
